import React from 'react';
import { useDataLoaderNew } from 'data-loader';
import { useProjectsService } from 'nekst-api';
import { CopyValueToClipboard } from 'features/nekst-widgets';

export interface SendByEmailAddressWidgetProps {
  projectId: number;
}

export function SendByEmailAddressWidget(props: SendByEmailAddressWidgetProps) {
  const projectsService = useProjectsService();

  const { data, loading } = useDataLoaderNew(
    async () => {
      return await projectsService.getProjectEmailAddress(props.projectId);
    },
    {
      dependencies: [props.projectId],
    },
  );

  if (loading || !data) {
    return null;
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <span style={{ fontSize: '14px', color: '#666' }}>
        Email documents to: <strong>{data}</strong>
      </span>
      <CopyValueToClipboard text={data} />
    </div>
  );
}
